import React, { createContext, useContext, useEffect, useState } from "react";
import { adminAxios, getToken, setToken, clearToken } from "./api";

const AuthCtx = createContext(null);

export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  // null = checking, false = unauthenticated, object = authenticated user
  const [user, setUser] = useState(null);

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setUser(false);
      return;
    }
    adminAxios.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await adminAxios.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
